import axios from "axios";
import { app } from "../config";
import { TOKEN_LS_, USER_LS_, getMe } from "./login.service";

let URL = "https://mt5apis.strelasoft.com/ff-manager-api"; // "http://44.212.59.222/backend/api" git@github.com:azazel2820/abh-manager-crm-fe.git

URL = "https://mt5apis.strelasoft.com/ff-manager-api";

const api = axios.create({
  baseURL: URL
});

export const sqlApi = axios.create({
  baseURL: "http://18.216.108.254/testproject"
});

export default api;

api.interceptors.request.use(function (config) {
  let userStr = localStorage.getItem(USER_LS_);

  let tokenStr = localStorage.getItem(TOKEN_LS_);

  if (tokenStr) {
    config.headers.Authorization = tokenStr;
  }

  if (userStr) {
    let userArray = userStr.split("__USER__");
    if (userArray.length == 2) {
      config.headers.login = parseInt(userArray[0]);
      config.headers.pass = userArray[1];
    }
  }

  return config;
});
